const initialState = {
    locationBeforeTransitions: {
        key: 0,
        pathname: window.location.pathname,
    },
};

const routing = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default routing;